import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=0ed36fda&scoped=true&"
import script from "./UserBlock.vue?vue&type=script&lang=js&"
export * from "./UserBlock.vue?vue&type=script&lang=js&"
import style0 from "./UserBlock.vue?vue&type=style&index=0&id=0ed36fda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed36fda",
  null
  
)

export default component.exports